import { useContext } from 'react';
import { FormStateContext } from '../Context.js';

/* ----------------------- useFormState ----------------------- */
function useFormState() {
  var formState = useContext(FormStateContext);
  return formState;
}

export { useFormState };
